import { IMyEcabPersonDto } from '../services/api.clients.generated';

export const PERSON_SEARCH_DEBOUNCE_MS = 400;

export function getPersonPrimaryLabel(person: IMyEcabPersonDto | null | undefined): string {
  if (!person) {
    return '';
  }

  const name = `${person.firstName || ''} ${person.lastName || ''}`.trim();
  return name || person.companyName || '';
}

export function getPersonLocality(person: IMyEcabPersonDto | null | undefined): string {
  return person?.addresses?.[0]?.['address']?.['street']?.locality?.name || '';
}

export function formatPersonDisplay(person: IMyEcabPersonDto | string | null | undefined): string {
  if (!person) {
    return '';
  }

  if (typeof person === 'string') {
    return person;
  }

  const primaryLabel = getPersonPrimaryLabel(person);
  if (!primaryLabel) {
    return '';
  }

  let birthDate = '';
  if (person.birthDate) {
    const parsedDate = new Date(person.birthDate);
    if (!Number.isNaN(parsedDate.getTime())) {
      birthDate = ` (${parsedDate.toLocaleDateString('fr-CH')})`;
    }
  }

  const locality = getPersonLocality(person);
  const localitySuffix = locality ? ` - ${locality}` : '';

  return `${primaryLabel}${birthDate}${localitySuffix}`;
}

export function getPersonOptionScore(person: IMyEcabPersonDto): number {
  const hasBirthDate = !!person.birthDate;
  const hasLocality = !!getPersonLocality(person);

  if (hasBirthDate && hasLocality) {
    return 4;
  }
  if (hasLocality) {
    return 3;
  }
  if (hasBirthDate) {
    return 2;
  }

  return 1;
}

export function sortPersonOptions(persons: IMyEcabPersonDto[] | null | undefined): IMyEcabPersonDto[] {
  if (!persons?.length) {
    return [];
  }

  return [...persons].sort((left, right) => getPersonOptionScore(right) - getPersonOptionScore(left));
}